import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {
    overflowY: 'hidden',
  },
  item: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#347873',
    },
  },
  arrow: {
    marginRight: '6px',
    display: 'inline-block',
    userSelect: 'none',
    transition: 'all 0.1s',
    cursor: 'pointer',
    '&:after': {
      content: "'▾'",
    },
  },
  arrowCollapsed: {
    transform: 'rotate(-90deg)',
  },
  container: {},
  containerContent: {
    padding: '8px 12px 8px 12px',
  },
  containerCollapsed: {
    height: '0px',
  },
});

class ContentDebuggerTree extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
  };

  state = {
    collapsed: true,
  };

  handleClick = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const { classes, children, label, ...otherProps } = this.props; // eslint-disable-line

    const arrowClass = classNames({
      [classes.arrow]: true,
      [classes.arrowCollapsed]: this.state.collapsed,
    });

    const containerClass = classNames({
      [classes.container]: true,
      [classes.containerCollapsed]: this.state.collapsed,
    });

    return (
      <div className={classes.root}>
        <div className={classes.item} onClick={this.handleClick}>
          <div className={arrowClass} />
          {label}
        </div>
        <div className={containerClass}>
          <div className={classes.containerContent}>{children}</div>
        </div>
      </div>
    );
  }
}

export default styled(ContentDebuggerTree)(styles);
